"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusWindow = void 0;
/**
 * Nexus独立窗口管理器
 * 允许直接创建独立窗口，无需依赖Cocos Creator的面板系统
 */
class NexusWindow {
    constructor(panel, config) {
        this.windowElement = null;
        this.isVisible = false;
        this.panel = panel;
        this.config = config;
    }
    /**
     * 创建并显示独立窗口
     */
    static create(panel, config) {
        const finalConfig = {
            title: "Nexus窗口",
            width: 800,
            height: 600,
            resizable: true,
            dockable: false,
            ...config
        };
        const window = new NexusWindow(panel, finalConfig);
        const windowId = `nexus-window-${Date.now()}`;
        NexusWindow.windows.set(windowId, window);
        window.show();
        return window;
    }
    /**
     * 显示窗口
     */
    show() {
        if (this.isVisible)
            return;
        this.createWindowElement();
        this.isVisible = true;
        // 初始化面板
        this.panel.onInit();
        this.panel.setContainer(this.windowElement.querySelector('.nexus-window-content'));
        // 开始渲染循环
        this.startRenderLoop();
    }
    /**
     * 隐藏窗口
     */
    hide() {
        if (!this.isVisible)
            return;
        if (this.windowElement) {
            this.windowElement.remove();
            this.windowElement = null;
        }
        this.isVisible = false;
    }
    /**
     * 关闭窗口
     */
    close() {
        this.hide();
        this.panel.onDestroy();
        // 从管理器中移除
        NexusWindow.windows.forEach((window, id) => {
            if (window === this) {
                NexusWindow.windows.delete(id);
            }
        });
    }
    /**
     * 创建窗口元素
     */
    createWindowElement() {
        // 创建遮罩层
        const overlay = document.createElement('div');
        overlay.className = 'nexus-window-overlay';
        overlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
        `;
        // 创建窗口
        const window = document.createElement('div');
        window.className = 'nexus-window';
        window.style.cssText = `
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
            width: ${this.config.width}px;
            height: ${this.config.height}px;
            max-width: 90vw;
            max-height: 90vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        `;
        // 创建标题栏
        const titleBar = document.createElement('div');
        titleBar.className = 'nexus-window-titlebar';
        titleBar.style.cssText = `
            background-color: #f0f0f0;
            padding: 12px 16px;
            border-bottom: 1px solid #e0e0e0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: move;
        `;
        const title = document.createElement('h3');
        title.textContent = this.config.title;
        title.style.cssText = `
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #333;
        `;
        const closeButton = document.createElement('button');
        closeButton.textContent = '×';
        closeButton.style.cssText = `
            background: none;
            border: none;
            font-size: 18px;
            cursor: pointer;
            color: #666;
            padding: 4px 8px;
            border-radius: 4px;
        `;
        closeButton.onclick = () => this.close();
        titleBar.appendChild(title);
        titleBar.appendChild(closeButton);
        // 创建内容区域
        const content = document.createElement('div');
        content.className = 'nexus-window-content';
        content.style.cssText = `
            flex: 1;
            padding: 16px;
            overflow: auto;
            background-color: #fafafa;
        `;
        window.appendChild(titleBar);
        window.appendChild(content);
        overlay.appendChild(window);
        // 添加拖拽功能
        this.addDragFunctionality(titleBar, window);
        // 点击遮罩层关闭窗口
        overlay.onclick = (e) => {
            if (e.target === overlay) {
                this.close();
            }
        };
        // 添加到页面
        document.body.appendChild(overlay);
        this.windowElement = overlay;
    }
    /**
     * 添加拖拽功能
     */
    addDragFunctionality(titleBar, window) {
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let startLeft = 0;
        let startTop = 0;
        titleBar.onmousedown = (e) => {
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            const rect = window.getBoundingClientRect();
            startLeft = rect.left;
            startTop = rect.top;
            document.onmousemove = (e) => {
                if (!isDragging)
                    return;
                const deltaX = e.clientX - startX;
                const deltaY = e.clientY - startY;
                window.style.position = 'fixed';
                window.style.left = `${startLeft + deltaX}px`;
                window.style.top = `${startTop + deltaY}px`;
                window.style.transform = 'none';
            };
            document.onmouseup = () => {
                isDragging = false;
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };
    }
    /**
     * 开始渲染循环
     */
    startRenderLoop() {
        const render = () => {
            if (this.isVisible && this.panel) {
                this.panel.render();
            }
            if (this.isVisible) {
                requestAnimationFrame(render);
            }
        };
        requestAnimationFrame(render);
    }
    /**
     * 获取所有打开的窗口
     */
    static getAllWindows() {
        return Array.from(NexusWindow.windows.values());
    }
    /**
     * 关闭所有窗口
     */
    static closeAll() {
        NexusWindow.windows.forEach(window => window.close());
        NexusWindow.windows.clear();
    }
}
exports.NexusWindow = NexusWindow;
NexusWindow.windows = new Map();
